<div class="payment-container" [ngStyle]="{'padding': paymentForSubscription ? '0' : '1rem'}">
  <div class="header" *ngIf="!paymentForSubscription">
    <div class="section-title">Payment</div>
    <div class="close-btn" (click)="onClickCancel()">
      <i class="fa-solid fa-xmark"></i>
    </div>
  </div>
  <div class="body" [ngStyle]="{'padding': paymentForSubscription ? '0' : '1rem'}">
    <div class="inner-body">
      <div class="left-body">
        <div class="body-title" *ngIf="!paymentForSubscription">Confirm your details!</div>
        <div class="form" [formGroup]="paymentForm">
          <div class="name">
            <select formControlName="title" [ngClass]="{
                'error-border':
                  paymentForm.get('title').value == '' && submitted
              }">
              <option value="" disabled selected hidden>Title</option>
              <option *ngFor="let name of title" [value]="name">
                {{ name }}
              </option>
            </select>
            <input type="text" [ngClass]="{
                'error-border':
                  paymentForm.get('first_name').value == '' && submitted
              }" formControlName="first_name" class="first-name" pInputText placeholder="first name" />
            <input type="text" [ngClass]="{
                'error-border':
                  paymentForm.get('last_name').value == '' && submitted
              }" formControlName="last_name" class="last-name" pInputText placeholder="last name" />
          </div>
          <div class="mobile">
            <input name="code" formControlName="country_code" [ngClass]="{
                'error-border':
                  paymentForm.get('country_code').value == '' && submitted
              }" class="code" pInputText autocomplete="off" type="text" placeholder="code" />
            <input name="number" formControlName="phone" [ngClass]="{
                'error-border':
                  paymentForm.get('phone').value == '' && submitted
              }" autocomplete="off" class="number" pInputText type="text" placeholder="phone number" />
          </div>
          <input name="email" formControlName="email" [ngClass]="{
              'error-border': paymentForm.get('email').value == '' && submitted
            }" autocomplete="off" type="email" id="email" pInputText placeholder="e-mail ID" />
          <select formControlName="payment_type" [ngClass]="{
            'error-border':
              paymentForm.get('payment_type').value == '' && submitted
          }">
            <option value="" disabled selected hidden>Choose Payment Mode</option>
            <option *ngFor="let type of paymentTypes" [value]="type">
              {{ type }}
            </option>
          </select>
          <select *ngIf="paymentForSubscription" formControlName="tenure_in_months" [ngClass]="{
            'error-border':
              paymentForm.get('tenure_in_months').value == '' && submitted
          }">
            <option value="" disabled selected hidden>Choose Tenure in Months</option>
            <option *ngFor="let tenure of tenureInMonths" [value]="tenure.value">
              {{ tenure.label }}
            </option>
          </select>
          <input *ngIf="paymentForm.get('payment_type').value === 'UPI'" name="upiId" formControlName="upi_id"
            [ngClass]="{
              'error-border': paymentForm.get('upi_id').value == '' && submitted
            }" autocomplete="off" type="text" pInputText placeholder="UPI ID" />
          <input name="transactionId" formControlName="transaction_id" [ngClass]="{
              'error-border':
                paymentForm.get('transaction_id').value == '' && submitted
            }" autocomplete="off" type="text" pInputText placeholder="Transaction ID" />
        </div>
      </div>
      <div class="right-body">
        <div class="qr-code-section" *ngIf="paymentForm.get('payment_type').value === 'UPI'">
          <div class="qr-note">SCAN TO MAKE PAYMENT</div>
          <div class="qr-code">
            <img src="../../assets/images/tlm - payment QR.jpg" alt="" />
            <div class="upi-id">thelaboratorymatters.62739624@hdfcbank</div>
            <div class="price">Total Payable: {{ paymentForSubscription ? monthPriceMap[paymentForm.get('tenure_in_months').value] : courseDetails?.price }}/-</div>
          </div>
        </div>
        <div class="bank-details-section" *ngIf="paymentForm.get('payment_type').value === 'NEFT'">
          <div class="header">Bank Account Details</div>
          <div class="account-details">
            <div class="detail">
              <div class="label">Account Holder Name: </div>
              <div class="value">R Rani</div>
            </div>
            <div class="detail">
              <div class="label">Bank Name: </div>
              <div class="value">HDFC</div>
            </div>
            <div class="detail">
              <div class="label">Branch Name: </div>
              <div class="value">Besant Nagar</div>
            </div>
            <div class="detail">
              <div class="label">Account Number: </div>
              <div class="value">50200077479936</div>
            </div>
            <div class="detail">
              <div class="label">Account Type: </div>
              <div class="value">Savings</div>
            </div>
            <div class="detail">
              <div class="label">IFSC Code: </div>
              <div class="value">HDFC0000010</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="outer-body">
      <div class="note">
        Sit tight! Your courses will be added to your dashboard, upon
        verification of payment.
      </div>
      <div class="submit-btn" (click)="onClickVerify()" *ngIf="!isLoading">
        <button>Verify</button>
      </div>
      <button type="submit" *ngIf="isLoading">
        Verifying
        <i class="fa-solid fa-spinner fa-spin"></i>
      </button>
    </div>
  </div>
</div>